module.exports = __webpack_public_path__ + "static/media/close.595f6dbe.svg";